<template>
    <div v-if="customers">
        <v-autocomplete
                v-model=selectedCustomer

                :items="customers.data"
                :loading="this.$apollo.queries.customers.loading"
                :search-input.sync="search"
                color="white"
                :item-text="itemTitle"
                item-value="id"
                placeholder="Start typing to Search"
                label="Customer Search"
                return-object
                @change="emitSelected"
                autocomplete="off"
                :disabled="disabled"
                clearable
        >


            <template v-slot:item="data">

                <template v-if="data.item">
                        <v-list-item-content>
                            <v-list-item-title>{{data.item.company}}</v-list-item-title>
                            <v-list-item-subtitle>{{data.item.contactName}}</v-list-item-subtitle>
                        </v-list-item-content>

                </template>
            </template>

        </v-autocomplete>
    </div>
</template>

<script>
    import CUSTOMERS_LIST from "../../graphql/Customer/List.gql";

    export default {
        data() {
            return {
                selectedCustomer: this.customer,
                currentCustomer: {},
                search: ''
            }
        },
        props: {
            customer: {
                type: Object,
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            customer() {
                this.selectedCustomer = this.customer
            },
        },
        apollo: {
            customers: {
                query: CUSTOMERS_LIST,
                variables() {

                    let where = {column: 'COMPANY', operator: 'IS_NOT_NULL'}

                    if (this.search !== '') {
                        where = {column: 'COMPANY', operator: 'LIKE', value: '%' + this.search + '%'}
                    }

                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: 'COMPANY'.toUpperCase(), order: 'ASC'},
                    }
                },
                update: data => data.customers
            },
        },
        methods: {
            itemTitle(item) {
                return item.company
            },

            emitSelected(item) {
                this.$emit('selected', item)
            }
        },
    }
</script>

<style scoped>

</style>